/**
 * Tomaruba Guest API
 * Tomaruba Guest API
 *
 * OpenAPI spec version: 1.0.0
 * Contact: development@tomaruba.me
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient'
import AutoActionMailContent from './AutoActionMailContent'

/**
 * The InlineResponse20029 model module.
 * @module model/InlineResponse20029
 * @version 1.0.0
 */
export default class InlineResponse20029 {
  /**
   * Constructs a new <code>InlineResponse20029</code>.
   * @alias module:model/InlineResponse20029
   * @class
   */

  constructor() {}

  /**
   * Constructs a <code>InlineResponse20029</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/InlineResponse20029} obj Optional instance to populate.
   * @return {module:model/InlineResponse20029} The populated <code>InlineResponse20029</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new InlineResponse20029()

      if (data.hasOwnProperty('auto_action_mail_content')) {
        obj['auto_action_mail_content'] = AutoActionMailContent.constructFromObject(data['auto_action_mail_content'])
      }
    }
    return obj
  }

  /**
   * @member {module:model/AutoActionMailContent} auto_action_mail_content
   */
  auto_action_mail_content = undefined
}
